import styled from '@emotion/styled'
import { Button } from '@chakra-ui/react'

export const WeekDayButton = styled(Button)`
    border-radius: 50%;
`
